import { ContentHubData } from "@app/types/ServerCustomContext";
import { configTeaser } from "@pub/config";
import placeholders from "@pub/placeholders";
import { AnchorBlock, LatestArticle } from "@sphtech/dmg-design-system";
import cx from "classnames";

import styles from "../contenthub.module.css";

type Props = {
  data: Omit<ContentHubData, "metaData">;
  from?: number;
  limit?: number;
};

export default function ContentHubBlockI({ data, from = 0, limit = 7 }: Props) {
  const topStories = data.topStories && data.topStories.slice(from, limit);
  if (!topStories?.[0]) {
    return null;
  }
  return (
    <section className={styles.contentHubBlockI}>
      <div
        className={cx(
          styles.bodyContainer,
          styles.contenthubLatestStories,
          styles.flex,
        )}
      >
        <div className={cx(styles.latestArticleContainer)}>
          <AnchorBlock
            {...topStories[0]}
            displayPublishDate={configTeaser.publishDate}
            mobileCrop={configTeaser.anchorBlock?.mobileCrop}
          />
        </div>

        <div className={styles.masonryLayout}>
          {topStories.slice(1).map((teaser, index: number) => (
            <div key={index} className={styles.masonryItem}>
              <LatestArticle
                key={index}
                {...teaser}
                mode="original"
                displayPublishDate={configTeaser.publishDate}
                placeholders={placeholders}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
